import { useEffect, useState } from 'react'
import type { i18n as I18n } from 'i18next'
import { adminApi } from '../../services'
import { LANGUAGE_STORAGE_KEY } from '../../i18n'

interface UseLanguageSyncArgs {
  settings: { language?: unknown } | null | undefined
  i18n: I18n
}

export function useLanguageSync({ settings, i18n }: UseLanguageSyncArgs): void {
  useEffect(() => {
    if (!settings) return
    const dbLanguage = settings.language
    if (typeof dbLanguage === 'string' && dbLanguage !== i18n.language) {
      void i18n.changeLanguage(dbLanguage)
      localStorage.setItem(LANGUAGE_STORAGE_KEY, dbLanguage)
    }
  }, [settings, i18n])
}

export function useOrgName(
  isPlatformAdmin: boolean,
  organisationId: string | null | undefined
): string | null {
  const [orgName, setOrgName] = useState<string | null>(null)

  useEffect(() => {
    if (isPlatformAdmin || !organisationId) return
    adminApi
      .getOrganisation(organisationId)
      .then((org) => {
        setOrgName(org.name)
      })
      .catch(() => {
        /* ignore */
      })
  }, [isPlatformAdmin, organisationId])

  return orgName
}
